import { MarketCard, EventGroup, CreationContext } from "../../types";

export function createOfferCard(
  _: EventGroup[],
  context: CreationContext
): Array<MarketCard> {
  const offer = new MarketCard({
    type: "offer",
    eventId: "",
    marketIds: [],
    optionIds: null
  });
  // Allow the preview to turn off the offer
  if (context?.preview.isPreview && context?.preview.hideOffer) {
    return [];
  }

  // If there's an offer defined then return an offer card
  if (context.offer) {
    return [offer];
  }

  return [];
}
